// WRAPPER FOR DECORATION
export const action = name => `@@ACTION/${name}`;

export const UPDATE_SHARE = action('UPDATE_SHARE');
export const UPDATE_TIMELINE = action('UPDATE_TIMELINE');
